import { trackClientEvent } from '../../../../../trackClientEvent';
import { timingPairStringify, } from '@faire/web/common/timings/TimingMarker';
export const eventKey = 'client_events-client_side_latency-timing';
/**
 * Timing event that tracks the client-side endpoint latency.
 */
export function trackClientEventsClientSideLatencyTiming(timingParameterToken, Endpoint) {
    var _a;
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            timingParameterToken: (_a = timingPairStringify(timingParameterToken)) !== null && _a !== void 0 ? _a : '',
            Endpoint,
        },
    });
}
